'use client'
import { useState } from 'react'

type UseProductVoucherLabelInteractiveControls = () => {
  closeDialog: () => void
  isDialogOpen: boolean
  openDialog: () => void
}

export const useProductVoucherLabelInteractiveControls: UseProductVoucherLabelInteractiveControls =
  () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false)

    const closeDialog = (): void => {
      setIsDialogOpen(false)
    }

    const openDialog = (): void => {
      setIsDialogOpen(true)
    }

    return {
      closeDialog,
      isDialogOpen,
      openDialog,
    }
  }
